<template>

    <span class="ui-text-label" :class="classes">
        {{ title }}
        <slot></slot>
    </span>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-text-label'
})
export default class TextLabel extends Vue {

    @Prop({ type: String })
    title: string;

    @Prop({ type: String, default: 'primary' })
    color: string;

    @Prop({ type: String })
    type: string;

    get classes() {

        let classes = [];

        if(this.color){
            classes.push('color-' + this.color);
        }

        if(this.type){
            classes.push('type-' + this.type);
        }

        return classes;
    }
}

export type TextLabelComp = InstanceType<typeof TextLabel>
export type TextLabelProps = ComponentProps<TextLabelComp>
export const textLabelCompMixin = createComponentMixin(TextLabel)

</script>
<style src="../../../scss/component/ui/TextLabel.scss" lang="scss"></style>